import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

declare var RTA_API: string;

export interface DeploymentBulletinRequest {
  message: string;
  countdownSeconds: number;
}

export interface DeploymentBulletinResponse {
  success: boolean;
  message: string;
  sentBy: string;
  countdownSeconds: number;
  timestamp: Date;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BulletinService {
  private baseUrl: string = RTA_API.replace('/RTA', '/Bulletin');

  constructor(private http: HttpClient) {}

  sendDeploymentBulletin(request: DeploymentBulletinRequest): Observable<DeploymentBulletinResponse> {
    return this.http.post<DeploymentBulletinResponse>(
      `${this.baseUrl}/SendDeploymentBulletin`,
      request
    );
  }
}
